var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FormFieldType, } from '../../../interfaces/createApplication';
var FIELD_TYPE_BY_CONFIG_TYPE = {
    text: FormFieldType.Text,
    string: FormFieldType.Text,
    input: FormFieldType.Text,
    email: FormFieldType.Text,
    phone: FormFieldType.Text,
    tel: FormFieldType.Text,
    number: FormFieldType.Text,
    numeric: FormFieldType.Text,
    amount: FormFieldType.Amount,
    currency: FormFieldType.Amount,
    money: FormFieldType.Amount,
    select: FormFieldType.Select,
    dropdown: FormFieldType.Select,
    list: FormFieldType.Select,
    autocomplete: FormFieldType.AutoComplete,
    typeahead: FormFieldType.AutoComplete,
    date: FormFieldType.Date,
    datetime: FormFieldType.Date,
    textarea: FormFieldType.TextArea,
    multiline: FormFieldType.TextArea,
    comment: FormFieldType.TextArea,
    radio: FormFieldType.Radio,
    radiogroup: FormFieldType.Radio,
    checkbox: FormFieldType.CheckBox,
    boolean: FormFieldType.CheckBox,
    bool: FormFieldType.CheckBox,
    file: FormFieldType.File,
    upload: FormFieldType.File,
    document: FormFieldType.File,
};
var toText = function (value) {
    return value === null || value === undefined ? '' : String(value);
};
var firstText = function () {
    var candidates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        candidates[_i] = arguments[_i];
    }
    for (var index = 0; index < candidates.length; index += 1) {
        var text = toText(candidates[index]).trim();
        if (text) {
            return text;
        }
    }
    return '';
};
export var normaliseConfigKey = function (value) {
    return value.toLowerCase().replace(/[^a-z0-9]+/g, '');
};
var toDisplayLabel = function (rawName) {
    var spaced = rawName
        .replace(/[_-]+/g, ' ')
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/\s+/g, ' ')
        .trim();
    if (!spaced) {
        return '';
    }
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};
var toFieldType = function (entry) {
    var configType = toText(entry === null || entry === void 0 ? void 0 : entry.type).trim().toLowerCase();
    if (configType && FIELD_TYPE_BY_CONFIG_TYPE[configType]) {
        return FIELD_TYPE_BY_CONFIG_TYPE[configType];
    }
    if (Array.isArray(entry === null || entry === void 0 ? void 0 : entry.dropdownOptions) && entry.dropdownOptions.length > 0) {
        return FormFieldType.Select;
    }
    return FormFieldType.Text;
};
export var toConfiguredOptions = function (entry) {
    var configOptions = entry === null || entry === void 0 ? void 0 : entry.dropdownOptions;
    if (!Array.isArray(configOptions) || configOptions.length === 0) {
        return undefined;
    }
    var valueKey = toText(entry === null || entry === void 0 ? void 0 : entry.dropdownOptionValueKey).trim();
    var displayKey = toText(entry === null || entry === void 0 ? void 0 : entry.dropdownOptionDisplayKey).trim();
    return configOptions
        .map(function (option) {
        if (option === null || option === undefined) {
            return { label: '', value: '' };
        }
        if (typeof option !== 'object') {
            return { label: toText(option), value: toText(option) };
        }
        var label = firstText(displayKey ? option[displayKey] : undefined, option.label, option.Description, option.Name, option.text, option.value);
        var value = firstText(valueKey ? option[valueKey] : undefined, option.value, option.Code, option.Id, option.id, label);
        return { label: label, value: value };
    })
        .filter(function (option) { return option.label !== '' || option.value !== ''; });
};
export var readFieldValue = function (values, schemaName, apiFieldName) {
    var schemaValue = values === null || values === void 0 ? void 0 : values[schemaName];
    if (schemaValue !== undefined && schemaValue !== null && schemaValue !== '') {
        return schemaValue;
    }
    if (!values) {
        return '';
    }
    var configuredSuffix = "_".concat(normaliseConfigKey(apiFieldName));
    var configuredKey = Object.keys(values).find(function (key) {
        return key.toLowerCase().endsWith(configuredSuffix);
    });
    return configuredKey ? values[configuredKey] : '';
};
var toFieldName = function (sectionId, apiFieldName, fallbackIndex) {
    var key = normaliseConfigKey(apiFieldName) || "field".concat(fallbackIndex);
    return "".concat(sectionId, "_").concat(key);
};
var toFieldConfig = function (entry, entryIndex, sectionId) {
    var _a, _b, _c;
    if (!entry || entry.hideField) {
        return null;
    }
    var apiFieldName = toText((_a = entry.apiFieldName) !== null && _a !== void 0 ? _a : entry.name).trim();
    var label = toDisplayLabel(toText((_b = entry.name) !== null && _b !== void 0 ? _b : entry.apiFieldName)) || apiFieldName;
    var maxLength = Number((_c = entry === null || entry === void 0 ? void 0 : entry.maxLength) !== null && _c !== void 0 ? _c : 0);
    var tooltip = toText(entry === null || entry === void 0 ? void 0 : entry.toolTipMsg).trim();
    var startAdornment = toText(entry === null || entry === void 0 ? void 0 : entry.startAdornment).trim();
    var options = toConfiguredOptions(entry);
    var isReadOnly = entry.disabled === true || (entry === null || entry === void 0 ? void 0 : entry.isEditable) === false;
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({ name: toFieldName(sectionId, apiFieldName, entryIndex), apiFieldName: apiFieldName || undefined, label: label, type: toFieldType(entry), isMandatory: Boolean(entry.required) }, (entry.placeholder && { placeholder: entry.placeholder })), (tooltip && { tooltip: tooltip })), (maxLength > 0 && { maxLength: maxLength })), (startAdornment && { startAdornment: startAdornment })), (entry.defaultValue !== undefined && { defaultValue: entry.defaultValue })), (options && { options: options })), (isReadOnly && { isDisabled: function () { return true; } }));
};
var readSectionEntries = function (rawSection) {
    var _a;
    if (Array.isArray(rawSection)) {
        return rawSection;
    }
    if (rawSection && typeof rawSection === 'object') {
        var nested = (_a = rawSection.fields) !== null && _a !== void 0 ? _a : rawSection.Fields;
        if (Array.isArray(nested)) {
            return nested;
        }
        return Object.keys(rawSection)
            .map(function (key) { return rawSection[key]; })
            .filter(function (entry) { return entry && typeof entry === 'object' && !Array.isArray(entry); });
    }
    return [];
};
var readGroupSections = function (rawGroup) {
    var _a;
    if (Array.isArray(rawGroup)) {
        return [{ name: '', entries: rawGroup }];
    }
    if (!rawGroup || typeof rawGroup !== 'object') {
        return [];
    }
    var sections = (_a = rawGroup.sections) !== null && _a !== void 0 ? _a : rawGroup.Sections;
    if (sections && typeof sections === 'object') {
        return Object.keys(sections).map(function (sectionName) { return ({
            name: sectionName,
            entries: readSectionEntries(sections[sectionName]),
        }); });
    }
    return [{ name: '', entries: readSectionEntries(rawGroup) }];
};
export var buildConfiguredFields = function (entries, sectionId, context, buildOptions) {
    if (buildOptions === void 0) { buildOptions = {}; }
    var fields = (entries !== null && entries !== void 0 ? entries : [])
        .map(function (entry, entryIndex) { return toFieldConfig(entry, entryIndex, sectionId); })
        .filter(function (field) { return field !== null; });
    if (fields.length === 0 || !buildOptions.enhanceField) {
        return fields;
    }
    var fieldNamesByApiField = fields.reduce(function (names, field) {
        if (field.apiFieldName) {
            names[field.apiFieldName] = field.name;
        }
        return names;
    }, {});
    return fields.map(function (field) {
        var _a;
        return buildOptions.enhanceField(field, {
            apiFieldName: (_a = field.apiFieldName) !== null && _a !== void 0 ? _a : field.name,
            groupKey: context.groupKey,
            sectionKey: context.sectionKey,
            fieldNamesByApiField: fieldNamesByApiField,
        });
    });
};
export var readVendorConfigSections = function (fieldConfig) {
    if (!fieldConfig || typeof fieldConfig !== 'object') {
        return [];
    }
    return Object.keys(fieldConfig).reduce(function (sections, groupKey) {
        readGroupSections(fieldConfig[groupKey]).forEach(function (rawSection) {
            if (rawSection.entries.length > 0) {
                sections.push({
                    groupKey: groupKey,
                    sectionName: rawSection.name,
                    entries: rawSection.entries,
                });
            }
        });
        return sections;
    }, []);
};
export var toConfiguredSectionId = function (groupKey, sectionName) {
    return normaliseConfigKey("".concat(groupKey, " ").concat(sectionName)) || normaliseConfigKey(groupKey) || 'section';
};
export var buildGroupsFromFieldConfig = function (fieldConfig, buildOptions) {
    if (buildOptions === void 0) { buildOptions = {}; }
    if (!fieldConfig || typeof fieldConfig !== 'object') {
        return [];
    }
    var enhanceField = buildOptions.enhanceField;
    return Object.keys(fieldConfig).reduce(function (groups, groupKey) {
        var sections = readGroupSections(fieldConfig[groupKey]).reduce(function (keptSections, rawSection, sectionIndex) {
            var sectionId = toConfiguredSectionId(groupKey, rawSection.name || String(sectionIndex));
            var fields = buildConfiguredFields(rawSection.entries, sectionId, { groupKey: groupKey, sectionKey: rawSection.name }, { enhanceField: enhanceField });
            if (fields.length === 0) {
                return keptSections;
            }
            var formGroup = {
                id: "".concat(sectionId, "-group"),
                fields: fields,
            };
            keptSections.push({
                id: sectionId,
                title: toDisplayLabel(rawSection.name) || toDisplayLabel(groupKey),
                groups: [formGroup],
            });
            return keptSections;
        }, []);
        if (sections.length > 0) {
            groups.push({ key: groupKey, label: toDisplayLabel(groupKey) || groupKey, sections: sections });
        }
        return groups;
    }, []);
};
var buildSectionsFromFieldConfig = function (fieldConfig, buildOptions) {
    if (buildOptions === void 0) { buildOptions = {}; }
    return buildGroupsFromFieldConfig(fieldConfig, buildOptions).reduce(function (sections, group) { return sections.concat(group.sections); }, []);
};
export var isEmptyFieldConfig = function (fieldConfig) {
    return buildGroupsFromFieldConfig(fieldConfig).length === 0;
};
